// ** Third Party Imports
import styled from 'styled-components'

// ** Component Imports
import { Typography } from '@/shared/ui'

export const Details = styled.div`
	display: flex;
	row-gap: 1rem;
	width: 100%;
	flex-direction: column;
`

export const HeadlinePrice = styled.div`
	display: flex;
	column-gap: 0.5rem;
	align-items: baseline;
	flex-wrap: wrap;
`

export const MutedText = styled(Typography)`
	color: ${({ theme }) => theme.pallette.text.black75};
`

export const DetailRow = styled.div`
	display: flex;
	column-gap: 1rem;
	row-gap: 0.25rem;
	flex-wrap: wrap;
	justify-content: space-between;
`

export const NoteBox = styled.div`
	padding: 0.75rem 1rem;
	border-radius: 0.5rem;
	white-space: pre-wrap;
	border: 1px solid ${({ theme }) => theme.pallette.primary.greenBackground};
	background-color: ${({ theme }) => theme.pallette.primary.greenBackground20};

	& > p {
		color: ${({ theme }) => theme.pallette.text.black75};
	}
`

export const UnavailableBox = styled.div`
	padding: 0.75rem 1rem;
	border-radius: 0.5rem;
	border: 1px solid ${({ theme }) => theme.pallette.warning.main};
	background-color: ${({ theme }) => theme.pallette.warning.second};

	& > p {
		color: ${({ theme }) => theme.pallette.text.black75};
	}
`

export const TiersTable = styled.table`
	width: 100%;
	border-collapse: collapse;

	th,
	td {
		padding: 0.5rem 0.25rem;
		font-size: 0.875rem;
		text-align: left;
		border-bottom: 1px solid ${({ theme }) => theme.pallette.gray.default};
	}

	th {
		font-size: 0.75rem;
		font-weight: 500;
		color: ${({ theme }) => theme.pallette.text.black50};
	}

	td:last-child,
	th:last-child {
		text-align: right;
	}
`
